import React from "react";
import LocaleStrings from "@language";

const TicketPriceChangedPopup = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-fade-in-up">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <svg
            className="w-12 h-12 text-yellow-500"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 1010 10A10 10 0 0012 2z"
            />
          </svg>
        </div>

        {/* Message */}
        <h2 className="text-xl font-semibold text-center text-gray-800 mb-2">
          {LocaleStrings.kTicketPriceUpdate}
        </h2>
        <p className="text-gray-600 text-center mb-6">
          {LocaleStrings.kTicketPriceUpdateDesc}
        </p>

        {/* OK Button */}
        <div className="flex justify-end">
          <button onClick={onClose} className="theme-button-md">
            {LocaleStrings.kOk}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TicketPriceChangedPopup;
